import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import ManageProducts from "./scenes/ManageProducts";
import MasterDataRequest from "./scenes/MasterDataRequest";
import ManageRequests from "./scenes/ManageRequests";
import MyRequests from "./scenes/MyRequests";
import Procurement from "./scenes/Procurement";


class Tools extends Component {


    render() {

        return (
            <Switch>
                <Route path='/tools/manageProducts' component={ManageProducts}/>
                <Route path='/tools/masterDataRequests' component={MasterDataRequest}/>
                <Route path='/tools/manageRequests' component={ManageRequests}/>
                <Route path='/tools/myRequests' component={MyRequests}/>
                <Route path='/tools/procurement' component={Procurement}/>
            </Switch>
        );
    }
}

export default Tools;



// WEBPACK FOOTER //
// ./src/scenes/Tools/index.js